import React from 'react';

/**
 * CommonTabPanel - A reusable tab panel component for Material-UI Tabs.
 *
 * Props:
 * - value: number (current selected tab index)
 * - index: number (this panel's index)
 * - children: ReactNode (panel content)
 * - ...rest: any other props for the div
 */
function CommonTabPanel({ value, index, children, ...rest }) {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ height: '100%' }}
      {...rest}>
      {value === index && children}
    </div>
  );
}

export default CommonTabPanel;
